import React, { Component, ComponentType } from 'react';
import debounce from 'debounce';

type SearchFunction = (search: string) => void;

export interface WithContextSearchProps {
  onContextSearchChange: (
    refreshCallback: VoidFunction,
    setSearchCallback: SearchFunction,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  onFrontSearchChange: (searchCallback: SearchFunction, e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * HOC dostarczający logikę dla komponetu zakładki korzystającego z Context Search - wyszukiwania kontekstowego.
 *
 * @param Cmp
 */
function withContextSearch(Cmp: ComponentType<any>): any {
  class Controller extends Component<any> {
    /*
      Funkcja używana do przeszukiwania kontekstowego danych "po backendzie". Wykonywana przy zmianach na inpucie.
      Jako parametry należy podać:
      - funkcję odpalającą refresh danych dla zakładki,
      - funkcję zmieniającą parametr 'search' w redux,

      Refresh callback służy do odpalenia odświeżenia danych.
      Wykorzystuje funkcję delayInputChangeBackend do opóźnienia reakcji na zmiany w inpucie.
      */
    onContextSearchChange = (
      refreshCallback: VoidFunction,
      setSearchCallback: SearchFunction,
      e: React.ChangeEvent<HTMLInputElement>,
    ): void => {
      setSearchCallback(e.currentTarget.value.toLowerCase().trim());
      this.delayInputChangeBackend(refreshCallback);
    };

    delayInputChangeBackend = debounce((searchCallback: VoidFunction): void => searchCallback(), 500);

    /*
      Funkcja używana do przeszukiwania kontekstowego danych "po froncie"
      Jako parametry należy podać:
      - funkcję zmieniającą parametr 'search' w redux.

      Wykorzystuje funkcję delayInputChangeFrontend do opóźnienia reakcji na zmiany w inpucie.
    */
    onFrontSearchChange = (searchCallback: SearchFunction, e: React.ChangeEvent<HTMLInputElement>) => {
      let value;
      if (e && e.currentTarget) value = e.currentTarget.value.trim();
      else value = '';
      return this.delayInputChangeFrontend(searchCallback, value.toLowerCase());
    };

    delayInputChangeFrontend = debounce((searchCallback: SearchFunction, value: string): void => searchCallback(value), 500);

    render(): React.ReactNode {
      return (
        <Cmp {...this.props} onContextSearchChange={this.onContextSearchChange} onFrontSearchChange={this.onFrontSearchChange} />
      );
    }
  }
  return Controller;
}
export default withContextSearch;
